import { HotelResultsViewModel } from 'models';
import { FullPropertySearch, OperationResult } from '__generated__/api';

import {
  createSearchAndFilterDisplayOptions,
  getDefaultRequestFields,
  mapLoyaltyEducation,
  mapMap,
  mapOmnitureData,
  mapPropertySearchMessage,
  mapPropertySearchResults,
  mapResultTitleViewModel,
  mapSearchedDestination,
  mapSortAndFilter,
  SearchMigrationAdapter
} from 'stores/adapters';

export const adaptFullPropertySearch: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<FullPropertySearch.Query>
): HotelResultsViewModel => {
  const { data, extensions } = bexApiResults;

  if (!data || !data.propertySearch) {
    return bffResults;
  }

  return {
    ...bffResults,
    sortAndFilter: mapSortAndFilter(data.propertySearch),
    searchAndFilterDisplayOptions: createSearchAndFilterDisplayOptions(data.propertySearch.sortAndFilter),
    hotels: mapPropertySearchResults(data),
    messages: mapPropertySearchMessage(data),
    searchedDestination: mapSearchedDestination(data),
    resultTitleModel: mapResultTitleViewModel(data),
    totalPropertyCount: data.propertySearch.summary.matchedPropertiesSize,
    defaultRequestFields: getDefaultRequestFields(data.propertySearch.searchCriteria, data.propertySearch.summary.region),
    omnitureData: mapOmnitureData(extensions.analytics),
    map: mapMap(data),
    loyaltyEducation: mapLoyaltyEducation(data),
    loyaltyMessagingModel: data.propertySearch.summary.loyaltyInfo && {
      loyaltyPointsMessage: data.propertySearch.summary.loyaltyInfo.saveWithPointsMessage,
      swpActionMessage: data.propertySearch.summary.loyaltyInfo.saveWithPointsActionMessage
    }
  };
};
